import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import RegistrationForm from "./components/RegistrationForm";
import RegistrationList from "./pages/RegistrationList";

function App() {
  return (
    <Router basename="">
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<RegistrationForm />} />
          <Route path="/admin_registrationList" element={<RegistrationList />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
